import { render, staticRenderFns } from "./PersonProfessionTags.vue?vue&type=template&id=aa205046"
import script from "./PersonProfessionTags.vue?vue&type=script&lang=js"
export * from "./PersonProfessionTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports